import { useEffect, useState } from 'react';
import { useRepositories } from '../../../infrastructure/http/RepositoryProvider';
import { weatherLocationFor, type WeatherLocation } from '../../../domain/DeviceLocation';
import type { AgroForecast } from '../../../domain/Weather';
import type { Device } from '../../../domain/Device';
import type { Site } from '../../../domain/Site';

// Pronóstico del lote: el del lugar de su primera estación con ubicación
// (GPS, marcada a mano o la de su campo).
export function useLotForecast(devices: Device[]) {
  const { weather, sites: siteRepo } = useRepositories();
  const [sites, setSites] = useState<Site[] | null>(null);
  const [forecast, setForecast] = useState<AgroForecast | null>(null);
  const [status, setStatus] = useState<'loading' | 'ok' | 'unset' | 'error'>('loading');

  useEffect(() => {
    let cancelled = false;
    siteRepo
      .list()
      .then((r) => !cancelled && setSites(r.sites))
      .catch(() => !cancelled && setSites([]));
    return () => {
      cancelled = true;
    };
  }, [siteRepo]);

  const location: WeatherLocation | null = sites
    ? (devices.map((d) => weatherLocationFor(d, sites)).find((l): l is WeatherLocation => l !== null) ?? null)
    : null;
  const key = location ? `${location.lat.toFixed(2)},${location.lon.toFixed(2)}` : null;

  useEffect(() => {
    if (sites === null) return;
    if (!location) {
      setStatus('unset');
      return;
    }
    let cancelled = false;
    setStatus('loading');
    weather
      .getAgroForecast(location.lat, location.lon)
      .then((data) => {
        if (cancelled) return;
        setForecast(data);
        setStatus('ok');
      })
      .catch(() => !cancelled && setStatus('error'));
    return () => {
      cancelled = true;
    };
    // La ubicación se compara por su clave (lat/lon redondeados), no por identidad.
  }, [key, sites === null, weather]);

  return { forecast, status, location };
}
